<template>
  <footer class="footer">
    <div class="footer-section row">
      <div class="left-section col-md-6">
        <p>{{ year }} Loyalty Refunds. Todos los derechos reservados <router-link to="/condiciones"> <br>
        Términos y condiciones</router-link> |
        <router-link to="/privacidad">Aviso de privacidad </router-link></p>
      </div>      
      <div class="right-section col-md-5">
        <br>
        <p>Tel. +52 (55) 6816 1001 / contacto@loyaltyrefunds.com</p>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
.footer{
  padding-top: 5px;
  border-top: 1px solid rgba(59, 59, 59, 0.178);
}
.footer-section{
  font-size: 10px;
  color: black;
}
.left-section{
  display: inline;
  margin: 15px;
}
.right-section{
  display: inline;
  margin: 10px;
  text-align: end;
}

@media screen and (min-width: 321px) and (max-width: 768px) { 
  .footer{
   width: 365px;
  }
  .left-section{
  display: inline;
  margin: 0px;
  text-align: center;
}
.right-section{
  margin: 0px;
  display: inline;
  text-align: center;
}
}
</style>
